import axios from 'axios';
import { closeModal, openModal } from '../common/simpleModal';

class LeadModal {
    constructor() {
        this.buttons = document.querySelectorAll('.lead-modal-button');
        this.buttonListeners = new Map();
        this.modal = document.querySelector('.lead-modal');

        this.init();
    }

    init() {
        let showModal = false;
        let currentButton = null;

        const leadSubmittedAt = localStorage.getItem('leadSubmittedAt');

        if (!leadSubmittedAt) {
            showModal = true;
        } else {
            const submittedDate = new Date(leadSubmittedAt);
            const now = new Date();

            if (
                submittedDate.getDate() < now.getDate() ||
                submittedDate.getMonth() < now.getMonth() ||
                submittedDate.getFullYear() < now.getFullYear()
            ) {
                showModal = true;
            }
        }

        if (showModal) {
            this.buttons.forEach(button => {
                const url = button.getAttribute('href');
                button.setAttribute('data-url', url);
                button.removeAttribute('href');
                button.classList.add('cursor-pointer');

                const clickListener = (event) => {
                    event.preventDefault();
                    currentButton = button;
                    openModal('.lead-modal');
                };
                button.addEventListener('click', clickListener);
                this.buttonListeners.set(button, clickListener);
            });

            this.modal.querySelector('.close-modal').addEventListener('click', () => {
                closeModal('.lead-modal');
            });

            this.modal.querySelector('.leadModal').addEventListener('submit', (event) => {
                event.preventDefault();

                const dataForm = new FormData(event.target);

                // Verifica se o botão tem atributo ref, caso contrário usa o textContent
                let referencia = '';
                if (currentButton.dataset.ref) {
                    referencia = currentButton.dataset.ref;
                } else {
                    referencia = currentButton.textContent.replace(/\s+/g, ' ').trim();
                }
                dataForm.append('ref', referencia);

                // localStorage.setItem('leadSubmittedAt', new Date().toISOString());

                this.buttons.forEach(button => {
                    button.setAttribute('href', button.getAttribute('data-url'));
                    button.classList.remove('cursor-pointer');

                    const clickListener = this.buttonListeners.get(button);
                    if (clickListener) {
                        button.removeEventListener('click', clickListener);
                    }
                });

                window.open(currentButton.getAttribute('data-url'), '_blank');

                closeModal('.lead-modal');

                axios({
                    method: 'POST',
                    url: base_url + 'storeLeadModal',
                    data: dataForm,
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                    .then(() => {
                        console.log('Formulário enviado com sucesso');
                    })
                    .catch(() => {
                        console.error('Erro ao enviar o formulário');
                    });
            });
        }
    }
}

if (document.querySelector('.lead-modal-button')) {
    new LeadModal();
}